import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * A way back to /admin from a portal page being previewed.
 *
 * WHY THIS IS GATED ON isAdmin
 * ----------------------------
 * The Layout Builder's "Preview page" navigates to the REAL portal route,
 * /portal/:state/:grade/:subject/:view. That is the right call — you see
 * exactly what a teacher sees, not an approximation. But it means there is no
 * preview chrome to put a close button on, and the page you land on is a page
 * students and teachers also use.
 *
 * So the button has to be conditional. An "Admin Dashboard" link rendered for
 * a third-grader is a link to a 403, and it tells them a door exists.
 * `isAdmin` comes from useAccessLevel, which both portal pages already
 * compute, so this costs nothing extra to check.
 *
 * Fixed rather than inline so it survives the portal's own scrolling and the
 * treasure map's full-bleed canvas, and offset from the top-left because the
 * treasure map already puts "← Back to Portal" there.
 */
const AdminBackButton = ({ isAdmin, label = "← Admin Dashboard", offset = false }) => {
  const navigate = useNavigate();

  if (!isAdmin) return null;

  return (
    <button
      type="button"
      className="admin-back-button"
      style={offset ? { top: "3.75rem" } : undefined}
      onClick={() => navigate("/admin")}
      title="Return to the Admin Dashboard"
    >
      {label}
    </button>
  );
};

export default AdminBackButton;
